import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Socialfeature() {
  return (
    <section className="app_feature p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Social Features</h2>
            <p>
              Similar to Facebook in functionality, TeeMates has specific
              features that make socializing easier like never before.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Socialfeature;
